import CategoryCard from '@/components/feature/CategoryCard';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            浏览分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按主题分类浏览，找到你最关心的安全指南内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.id}
              title={cat.name}
              slug={cat.slug}
              description={cat.description}
              icon={cat.icon}
              color={cat.color as 'primary' | 'accent' | 'secondary'}
              articleCount={cat.articleCount}
            />
          ))}
        </div>
      </div>
    </section>
  );
}